import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';
import { Button } from '@iwoca/orion';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import messages from './NotYetTopUpEligible.messages';
import topUpEligibleMessages from '../TopUpEligible/TopUpEligible.messages';
import styles from '../DashboardActions.module.css';
import dashboardCtaStyles from '../../../dashboardComponents/DashboardCTA/DashboardCTA.module.css';
import { connect } from 'react-redux';
import * as selectors from '../../../accountsSelector';
import { RootState } from '@iwProvider/configureStore';
import { TopupInEligibleSVG } from '@svgComponents/TopupInEligibleSVG/TopupInEligibleSVG';
import { intlFormatCurrency } from '@iwIntlProvider/FormattedCurrency';

const mapStateToProps = (state: RootState) => {
    const productType = selectors.getProductTypeFromURL();

    return {
        amountToRepayBeforeTopUp: selectors.amountToRepayBeforeTopUp(
            state,
            productType
        )
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

type Props = PropsFromRedux & WrappedComponentProps;

const NotYetTopUpEligible = ({ amountToRepayBeforeTopUp, intl }: Props) => {
    return (
        <DashboardCTA
            data-testid="top-up-ineligible-action"
            title={<FormattedMessage {...messages.title} />}
            className={dashboardCtaStyles.nonBottomDashboardAction}
            icon={<TopupInEligibleSVG />}
            description={
                <FormattedMessage
                    tagName="span"
                    {...messages.description}
                    values={{
                        strong: (chunks) => <strong>{chunks}</strong>,
                        amountToRepayBeforeTopUp: intlFormatCurrency({
                            intl,
                            value: amountToRepayBeforeTopUp
                        })
                    }}
                />
            }
            cta={
                <Button
                    data-testid="top-up-action-button"
                    variant="primary"
                    disabled
                    className={styles.dashboardActionCTA}
                >
                    <FormattedMessage {...topUpEligibleMessages.ctaText} />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(injectIntl(NotYetTopUpEligible));
